import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { FindProjectMembersResponse, FindProjectMembersQuery } from '@/@types/ProjectMember';
import { FindOneProjectQuery, FindOneProjectResponse, FindProjectTaskAttributeValueOptionsResponse, UpdateProjectCustomAttributesParam, UpdateProjectTaskAttributeValueOptionsParam, UpdateTaskAttributeValueOptionsQuery } from '@/@types/Project';
import { UpdateModeQueryDto } from '@/@types/Common';

export class ProjectMembersRepository {
  private readonly requestBasePath = 'v1/project-members';
  private readonly axios = new TheoryApiAxiosBase();

  async fetchProjectMembersById(projectId: number) {
    const response = await this.axios.get<FindProjectMembersResponse>(
      this.requestBasePath,
      {
        params: {
          'project-id': projectId,
          count: 10,
        }
      }
    );
    return response.data;
  }

  async findProjectMembers(query: FindProjectMembersQuery) {
    return (await this.axios.get<FindProjectMembersResponse>(
      this.requestBasePath,
      { params: query },
    )).data;
  }

  /** プロジェクト詳細取得 */
  async findOneProject (
    projectId: number,
    query: FindOneProjectQuery,
  ) {
    const endPoint = this.endPointCreator(projectId);
    return (await this.axios.get<FindOneProjectResponse>(
      endPoint,
      { params: query },
    )).data;
  }

  /** プロジェクトカスタム属性更新 */
  async updateProjectCustomAttributes (
    projectId: number,
    param: UpdateProjectCustomAttributesParam,
    query: UpdateModeQueryDto,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'custom-attributes',
    );
    await this.axios.patch(endPoint, param, { params: query });
  }

  /** 課題属性値選択項目更新 */
  async updateProjectTaskAttributeValueOptions (
    projectId: number,
    param: UpdateProjectTaskAttributeValueOptionsParam,
    query: UpdateTaskAttributeValueOptionsQuery,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'task-attributes',
    );
    await this.axios.patch(endPoint, param, { params: query });
  }

  /** 課題属性値選択項目一覧取得 */
  async findProjectTaskAttributeValueOptions (
    projectId: number,
  ) {
    const endPoint = this.endPointCreator(
      projectId,
      'task-attributes',
    );
    return (await this.axios.get<FindProjectTaskAttributeValueOptionsResponse>(
      endPoint,
    )).data;
  }

  private endPointCreator(...paths: (string | number)[]) {
    return this.util.endPointCreator(this.requestBasePath.project, ...paths);
  }
}
